module.exports = __webpack_public_path__ + "img/2.fa38bb4f.png";